export default {
  welcomes: 'Welcome to the backstage, please select other menu bars on the left',
  rules: {
    username: 'Account cannot be empty！',
    password: 'password can not be empty！',
    code: 'verification can not be empty！',
    form: {
      assist: 'Support',
      system: '商户管理后台',
      Login: 'LOG IN',
      UserName: 'Enter your username',
      Password: 'Enter your password',
      verification: 'Enter your verification code',
      Forgotpassword: '忘记秘密?',
      btnlogin: 'Log in',
      label: 'Simple, Speedy, Trouble-free',
      accountName: 'Username',
      password: 'Password',
      GoogleCode: 'Google verification code'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/login.js